const development_tenant = {
    notification: 'Bạn đang ở trong môi trường phát triển',
};
export default Object.freeze(development_tenant);
